import { PurchaseParams, SET_PURCHASE_PARAMS, SetPurchaseParamsAction } from './types';

export function setPurchaseParams(purchaseParams: PurchaseParams): SetPurchaseParamsAction {
	return {
		type: SET_PURCHASE_PARAMS,
		payload: purchaseParams,
	};
}
